import { TextInputComponent } from "components";
import { useFormProvider } from "../../../../providers";
import { useSerialNumber } from "hooks";

export function BrandComponent() {
  const { serialNumber } = useFormProvider();
  const { serialNumber: mSerialNumber } = useSerialNumber({ serialNumber });

  return (
    <TextInputComponent
      label="Merk"
      value={mSerialNumber && mSerialNumber.device.brand.name}
      disabled
    />
  );
}
